<template>
    <div class="w-full h-full flex flex-col justify-center">
        <div
            v-if="content.data?.content != null"
            class="prose flex flex-wrap flex-col max-w-none prose-headings:text-link prose-headings:font-semibold text-lg"
            v-html="content.data.content"
        />
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot
}>()
</script>

<style lang="postcss">
p[style*="text-align:center;"] {
    align-self: center;
}

.prose ul {
    list-style-position: outside;
}
</style>